import { createStyles, makeStyles, Theme, fade } from '@material-ui/core/styles';

import {
  BIG_MARGIN,
  colorsPalette,
  LARGE_MARGIN,
  MIDDLE_MARGIN,
  SMALL_MARGIN,
} from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      background: colorsPalette.blackSecondary,
      paddingTop: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        paddingTop: BIG_MARGIN,
      },
    },
    title: {
      width: '100%',
      paddingBottom: SMALL_MARGIN,
      marginBottom: SMALL_MARGIN,
      borderBottom: `1px solid ${fade(colorsPalette.white, 0.16)}`,
    },
    learnItemsWrapper: {
      marginBottom: SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        marginBottom: LARGE_MARGIN - SMALL_MARGIN,
        width: `calc(100% + ${MIDDLE_MARGIN}px)`,
        marginRight: `-${MIDDLE_MARGIN}px`,
      },
    },
    learnItem: {
      marginBottom: SMALL_MARGIN,
      display: 'flex',
      alignItems: 'center',
      paddingRight: MIDDLE_MARGIN,
    },
    learnItemIcon: {
      width: 24,
      height: 24,
      marginRight: SMALL_MARGIN / 2,
    },
    learnItemTitle: {
      flex: 1,
    },
    textBlock: {
      paddingBottom: MIDDLE_MARGIN - SMALL_MARGIN,
      [theme.breakpoints.up('md')]: {
        paddingBottom: LARGE_MARGIN - SMALL_MARGIN,
      },
    },
  }),
);

export default useStyles;
